import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination, Stack } from "@mui/material";
function AtlasTablePaginationActions(props) {
    const { count, page, rowsPerPage, onPageChange } = props;
    return (_jsx(Stack, Object.assign({ direction: "row", justifyContent: "flex-end", sx: { flexGrow: 1, flexShrink: 0 }, className: "AtlasTablePaginationActions" }, { children: _jsx(Pagination, { count: Math.ceil(count / rowsPerPage), page: page + 1, onChange: (e, p) => {
                onPageChange(e.nativeEvent, p - 1);
            } }) })));
}
export const TablePresets = () => {
    return {
        TableCell: {
            numeric: {
                sx: {
                    fontVariantNumeric: "tabular-nums",
                },
            },
        },
        TablePagination: {
            atlasTablePagination: {
                ActionsComponent: AtlasTablePaginationActions,
            },
        },
    };
};
//# sourceMappingURL=table.js.map